import { useSelector } from 'modules/react-redux';
import { memo } from 'react';

import { getActivePopup, getActiveReportConfig, getDocumentPreview } from '../../selectors/pageSelectors';
import { DocumentPreview } from '../DocumentPreview/DocumentPreview';
import { PrintPreviewNotificationPopup } from '../PrintPreviewNotificationPopup/PrintPreviewNotificationPopup';
import { PrintPreviewPopup } from '../PrintPreviewWindowPopup/PrintPreviewPopup';
import { ReportEditPopup } from '../ReportEditPopup/ReportEditPopup';
import { ReportSchedulerPopup } from '../ReportSchedulerPopup/ReportSchedulerPopup';
import { XeroAccrualManualJournalPopup } from '../XeroAccrualManualJournalPopup/XeroAccrualManualJournalPopup';
import { XeroAccrualReportPopup } from '../XeroAccrualReportPopup/XeroAccrualReportPopup';

export const ReportPopups = memo(() => {
    const documentPreview = useSelector(getDocumentPreview);

    const activePopup = useSelector(getActivePopup);
    const activeReportConfig = useSelector(getActiveReportConfig);

    const isPopupReportConfigExists = activePopup && 'reportConfig' in activePopup;
    const isActiveReportConfigExists = !!activeReportConfig;

    if (!isActiveReportConfigExists) {
        return null;
    }

    return (
        <>
            <XeroAccrualManualJournalPopup reportConfig={activeReportConfig} />

            <XeroAccrualReportPopup reportConfig={activeReportConfig} />

            <ReportSchedulerPopup reportConfig={activeReportConfig} />

            <PrintPreviewNotificationPopup />

            <PrintPreviewPopup />

            {isPopupReportConfigExists && <ReportEditPopup reportConfig={activePopup.reportConfig} />}

            {Boolean(documentPreview) && <DocumentPreview />}
        </>
    );
});

ReportPopups.displayName = 'ReportPopups';
